export default __webpack_public_path__ + "static/media/mission-vision.3b0bbce4.png";